import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createSavedItem } from '../services/savedItems'
import { CapturePayload, SavedItem } from '../types'
import { savedItemsKeys } from './queryKeys'

export function useSaveLink() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CapturePayload) => createSavedItem(payload),
    onSuccess: (createdItem: SavedItem) => {
      queryClient.invalidateQueries({ queryKey: savedItemsKeys.all })
      queryClient.setQueryData(savedItemsKeys.detail(createdItem.id), createdItem)
    },
  })
}
